import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=1b2ff0ac&scoped=true&"
import script from "./dataList.vue?vue&type=script&lang=js&"
export * from "./dataList.vue?vue&type=script&lang=js&"
import style0 from "./dataList.vue?vue&type=style&index=0&id=1b2ff0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ff0ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2ff0ac')) {
      api.createRecord('1b2ff0ac', component.options)
    } else {
      api.reload('1b2ff0ac', component.options)
    }
    module.hot.accept("./dataList.vue?vue&type=template&id=1b2ff0ac&scoped=true&", function () {
      api.rerender('1b2ff0ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/dataList.vue"
export default component.exports